export const WEB_CLIENT_TYPE = 'web'
export const SESSION_EXPIRED_CODE = 1007
export const SESSION_REPLACED_CODE = 1011

export function getWebDeviceId() {
  const existing = localStorage.getItem('deviceId')
  if (existing) {
    return existing
  }
  const deviceId = 'WEB-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
  localStorage.setItem('deviceId', deviceId)
  return deviceId
}

export function withWebClientMeta(data = {}) {
  return {
    ...data,
    clientType: WEB_CLIENT_TYPE,
    deviceId: getWebDeviceId()
  }
}

export function classifySessionFailure(response) {
  if (!response || response.status !== 401) {
    return ''
  }

  const code = Number(response.data?.code)
  if (code === SESSION_REPLACED_CODE) {
    return 'SESSION_REPLACED'
  }
  if (code === SESSION_EXPIRED_CODE || code === 401) {
    return 'TOKEN_EXPIRED'
  }

  const message = String(response.data?.message || '')
  if (message.includes('其他设备登录') || message.includes('Session mismatch') || message.includes('Token revoked')) {
    return 'SESSION_REPLACED'
  }
  if (message.includes('重新登录') || message.includes('过期')) {
    return 'TOKEN_EXPIRED'
  }
  return 'TOKEN_EXPIRED'
}

export function getSessionFailureMessage(reason) {
  if (reason === 'SESSION_REPLACED') {
    return '账号已在其他设备登录，请重新登录'
  }
  return '登录已过期，请重新登录'
}

export default {
  WEB_CLIENT_TYPE,
  SESSION_EXPIRED_CODE,
  SESSION_REPLACED_CODE,
  getWebDeviceId,
  withWebClientMeta,
  classifySessionFailure,
  getSessionFailureMessage
}
